// extracted by mini-css-extract-plugin
module.exports = {"card":"cv_bW","pictureWrapper":"cv_h0","animatedPicture":"cv_h1"};